/**
 * Regla de conteo de clases DE CARA AL ALUMNO (definida por Rodrigo, 2026-08-20):
 * las "clases" que se anuncian son las de contenido real — content, ai_mentor, embed.
 * Los quiz y las encuestas (multi o de una pregunta: ambas viven en type "quiz") son
 * momentos del recorrido, no clases, y contarlas inflaba el número ("18 clases" para
 * un curso de 7).
 *
 * OJO: esto es SÓLO para display. La matemática de progreso/completado/certificado
 * cuenta TODAS las lecciones (chapters.lesson_count y sus 9 consumidores) y no se toca:
 * un capítulo con quiz jamás se completaría si el total excluyera el quiz.
 */

type ConTipo = { type?: string | null };

export const isRealLesson = (lesson: ConTipo): boolean => lesson.type !== "quiz";

export const countRealLessons = (lessons: ReadonlyArray<ConTipo> | undefined | null): number =>
  (lessons ?? []).filter(isRealLesson).length;
